export const environment = {
  production: false,
  useContentfulPreview: true,
  contentful: {
    spaceId: 'lvzjl6djolps',
    accessToken: 'eANDyUYOHqjiK6FXTK7MS2d01ZJUsBda6U_5RrW47QM',
    previewAccessToken: 'x0LQxQq1hmgpZhcYr92_fv0ZVg-AVUaz2W5rk1BZnFM'
  },
  contentfulIds: {
    ladingPages: {
      landingPageV1: '1NbMknnlYKG1VACPvblxpw',

    },
    entrys: {
      formFlow: '3ZQGXgAxZPWbhIVntt8syF',
    }
  },
  IPQS: {
    api_key: "EuUF5PZtdqC6vhnUa8ce6BfWuDbdQuAM"
  },
  imageResolver: {
    defaultAlias: 'default',
    aliases: {
      default: 'https://landingimgresizer.azurewebsites.net/',
      svr2: 'https://landingimgresizer-dev.azurewebsites.net/',
      svr3: 'https://landingimgresizer-dev33.azurewebsites.net/'
    }
  },
  geocodeCache: {
    storageMode: 'local',
    ttlMs: 72 * 60 * 60 * 1000,
    maxEntries: 10,
    maxRetentionDays: 5
  },
  telemetry: {
    appInsightsConnectionString: 'InstrumentationKey=fb32d21d-9907-40d6-a437-108e2d9cdb83;IngestionEndpoint=https://centralus-2.in.applicationinsights.azure.com/;LiveEndpoint=https://centralus.livediagnostics.monitor.azure.com/;ApplicationId=e7a05edc-ae63-48f1-a758-5e12e5e6e348',
    enableDebugMode: true,
    segmentQueryParamName: 'telemetrySegment',
    debugQueryParamName: 'debugTelemetry',
    virtualPageViews: {
      enabled: true,
      formStepsEnabled: true,
      thankYouEnabled: true
    }
  }
};

export const googlemapskey = {
  key: "AIzaSyCoXbzHf_y74k7Y1tXWLqzxcaBj7yhThAY"
}
